import languageColorData from '@/components/GithubRepos/githubLanguageColors.json'

interface LanguageColorData {
  color: string | null // Color can be a string or explicitly null
  url: string
}

// Cast the imported JSON to the expected map structure for type safety
const languageColorsMap: Record<string, LanguageColorData> = languageColorData as Record<
  string,
  LanguageColorData
>

/**
 * Looks up the hexadecimal color code for a given GitHub language.
 *
 * @param language The language string from the GitHub API (e.g., 'HTML', 'Python').
 * @returns The hex color string (e.g., '#e34c26'), or null if the language is missing or has no assigned color.
 */
export function getLanguageColor(language: string | null): string | null {
  if (!language) {
    return null
  }

  // Look up the language information
  const languageInfo = languageColorsMap[language]

  // Check if the language exists in the map and return its color property.
  // We explicitly return languageInfo.color, which may be a string or null.
  return languageInfo ? languageInfo.color : null
}
